import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { font, palette } from 'styles/Global/globalStyles';
import moment from 'moment';
import 'moment/locale/ko';
import { TimeButtonProps, TimeInCalendarProps } from 'models/Common/calendarTypes';
import { BackgroundColor, BorderColor, PrimaryColor } from 'styles/Global/colorSemantic';

const TimeInCalendar = ({ setSelectedTime, selectedTime, selectedDate, serviceType }: TimeInCalendarProps) => {
    const [timeList, setTimeList] = useState<string[]>([]);

    useEffect(() => {
        moment.locale('ko');
        const now = moment();
        const selectedMoment = moment(selectedDate);
        const times = [];
        const opening = serviceType === 'counsel' ? selectedMoment.clone().hour(9).minute(0).second(0) : selectedMoment.clone().hour(0).minute(0).second(0);
        const closing = selectedMoment.clone().hour(20).minute(30).second(0);

        let start = opening.clone();

        if (selectedMoment.isSame(moment(), 'day')) {
            const now = moment();
            const nextSlot = now.minute() < 30 ? now.startOf('hour').add(30, 'minutes') : now.startOf('hour').add(1, 'hours');

            // 오늘이면 9:00과 nextSlot 중 더 늦은 시간부터 시작
            start = moment.max(opening, nextSlot);
        }

        if (start.isSameOrBefore(closing)) {
            while (start.isSameOrBefore(closing)) {
                times.push(start.format('A h:mm'));
                start.add(30, 'minutes');
            }
        }
        setSelectedTime && setSelectedTime(times[0]);
        setTimeList(times);
    }, [selectedDate]);
    // console.log(timeList, 'timeList');

    return (
        <>
            {timeList.map((time, idx) => (
                <TimeButton key={idx} onClick={() => setSelectedTime && setSelectedTime(time)} $selected={time === selectedTime}>
                    {time}
                </TimeButton>
            ))}
        </>
    );
};

export default TimeInCalendar;

const TimeButton = styled.button<TimeButtonProps>`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 88px;
    min-height: 40px;
    font-size: ${font.size[14]};
    border: 1px solid ${palette.testGray};
    border-radius: 4px;
    margin-left: 5px;
    ${(props) => props.$selected && `background-color: ${PrimaryColor.color_primary_normal}; color: ${palette.white}`};
    &:hover {
        background-color: ${(props) => !props.$selected && BackgroundColor.color_background_primary_normal};
        border-color: ${BorderColor.color_border_normal_hover};
    }
`;
